import { filelist } from "./filelists/filelist20250523";
import { filelist2 } from "./filelists/filelist20250523_2";

export default {
    id: 20250502,
    date: 20250502,
    uploadDate: '2.5.2025',
    title: 'Session des Kantonskirchenrates vom 23. Mai 2025',
    shortDescriptionString: `Ergebnisse in Kurzform / Informationsschreiben /  Traktanden / Sessionseinladung und Unterlagen`,
    subtitle: `Der Kantonskirchenrat plant seine ordentliche Frühlingssession auf den Freitag, 23. Mai 2025, im Kultur- und Kongresszentrum Zwei Raben, Hauptstrasse 20, 8840 Einsiedeln.`,
    sessionDate: '23.5.2025',    
    resultPdfs: filelist2,
    shortResults: [
        {
            name: 'sr1',
            value: 'Der Rechenschaftsbericht 2024 der Rekurskommission wurde genehmigt.'
        },
        {
            name: 'sr2',
            value: 'Der Nachkredit von Fr. 5’558.60 im Konto 31.365.00 Anderssprachigen-Seelsorge wurde gewährt.'
        },
        {
            name: 'sr3',
            value: 'Die Jahresrechnung 2024 und Bilanz per 31. Dezember 2024 wurden genehmigt.'
        },
        {
            name: 'sr4',
            value: 'Der Tätigkeitsbericht 2024 des Kantonalen Kirchenvorstandes wurde genehmigt.'
        },
        {
            name: 'sr5',
            value: 'Die Ergebnisse der Vernehmlassung bei den Kirchgemeinden zur Strategie der Kantonalkirche und die Strategie wurden zur Kenntnis genommen.'
        },
        {
            name: 'sr6',
            value: 'Der Beschluss über die weitere Mitfinanzierung der Spitalseelsorge wurde gefasst (dieser Beschluss unterliegt dem fakultativen Referendum).'
        },
        {
            name: 'sr7',
            value: 'Die Motion M 1-2024 “Betriebsfinanzierung Diakonie durch die Kantonalkirche” wurde für erheblich erklärt.'
        },
    ],
    Traktanden: [
        {
            name: 'tt1',
            value: 'Gebet, Begrüssung, Präsenz und Vereidigung eines Mitgliedes',
        },
        {
            name: 'tt2',
            value: 'Rechenschaftsbericht 2024 der Rekurskommission',
        },
        {
            name: 'tt3',
            value: 'Nachkredit für das Jahr 2024',
        },
        {
            name: 'tt4',
            value: 'Jahresrechnung 2024 und Bilanz per 31. Dezember 2024',
        },
        {
            name: 'tt5',
            value: 'Tätigkeitsbericht 2024 des Kantonalen Kirchenvorstandes',
        },
        {
            name: 'tt6',
            value: 'Ergebnisse der Vernehmlassung bei den Kirchgemeinden zur Strategie der Kantonalkirche und Kenntnisnahme der Strategie',
        },
        {
            name: 'tt7',
            value: 'Bericht und Antrag über die Mitfinanzierung der Röm.-kath. Spitalseelsorge ab dem Jahre 2026',
        },
        {
            name: 'tt8',
            value: 'Beantwortung der Motion M 1-2024 “Betriebsfinanzierung Diakonie durch die Kantonalkirche”',
        },
        {
            name: 'tt9',
            value: 'Informationen der Ressortchefs und Fragestunde',
        },
        {
            name: 'tt10',
            value: 'Verschiedenes',
        },
    ],
    Unterlagen: filelist
}